import { PRODUCTION_SCRIPTS } from './production';
import { UAT_SCRIPTS } from './uat';

export const scriptsByEnvironment = {
  uat: UAT_SCRIPTS,
  production: PRODUCTION_SCRIPTS,
};
